<template>
  <yd-dialog :title="'成长值明细'" :visible.sync="showGrowthStatistics" append-to-body width="80%">
    <el-table
      ref="table"
      v-loading="statisticsLoading"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        v-for="(item, index) in growthStatisticsTableColumns"
        :key="index"
        :align="item.align ? item.align : 'center'"
        :prop="item.filed"
        :label="item.title"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <template v-if="item.filed === 'remark'">
            <span>{{ scope.row.remarkStr }}</span>
            <el-button type="text" @click="viewOrderDetail(scope.row)">
              {{ scope.row.orderNo }}
            </el-button>
          </template>
          <template v-else>
            <span>{{ scope.row[`${item.filed}`] }}</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-justify-end" style="margin-top: 12px">
      <el-pagination
        @size-change="statisticsHandleSizeChagne"
        @current-change="statisticsHandleCurrentChange"
        :current-page="statisticsPageState.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="statisticsPageState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="statisticsPageState.total"
      />
    </div>
  </yd-dialog>
</template>

<script >
import { inject, computed } from '@vue/composition-api';
import { growthStatisticsTableColumns } from '../_data.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const showGrowthStatistics = inject('showGrowthStatistics');
  const analysisRemarkToOrderInfo = inject('analysisRemarkToOrderInfo');
  const viewOrderDetail = inject('viewOrderDetail');
  const statisticsLoading = inject('statisticsLoading');
  const statisticsTableData = inject('statisticsTableData');
  const statisticsPageState = inject('statisticsPageState');
  const statisticsHandleCurrentChange = inject('statisticsHandleCurrentChange');
  const statisticsHandleSizeChagne = inject('statisticsHandleSizeChagne');
  const tableData = computed(() => {
    let dataArr = statisticsTableData.value ? statisticsTableData.value : [];
    dataArr = dataArr.map(item => {
      if (item.remark) {
        const obj = analysisRemarkToOrderInfo(item.remark);
        item = {
          ...item,
          ...obj
        };
      }
      return item;
    });
    return dataArr;
  });
  return {
    growthStatisticsTableColumns,
    showGrowthStatistics,
    viewOrderDetail,
    statisticsLoading,
    statisticsPageState,
    statisticsHandleCurrentChange,
    statisticsHandleSizeChagne,
    tableData
  };
};
export default __sfc_main;
</script>
<style lang="scss" scoped></style>
